const PaymentDivider = () => {
  return <div className="w-full border-t border-light-700 my-5"></div>;
};

export { PaymentDivider };
